import videojs from 'video.js';

const Keyboard = function() {
    const player = this;
    let forwardTimer = null;

    const speeds = [0.5, 1, 1.25, 1.5, 2];
    function changePlaybackRate(direction) {
        let currentRate = player.playbackRate();
        let index = speeds.indexOf(currentRate);

        if (direction === 'up' && index < speeds.length - 1) {
            player.playbackRate(speeds[index + 1]);
        } else if (direction === 'down' && index > 0) {
            player.playbackRate(speeds[index - 1]);
        }
    }

    function handleKeyDown(event) {

        const activeElement = document.activeElement;
        const isInputFocused = activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA';

        if (isInputFocused) {
            return;
        }

        const key = event.key.toLowerCase();

        switch (key) {
            case 'm':
                event.preventDefault();
                player.muted(!player.muted());
                break;
            case ' ':
                event.preventDefault();
                if (player.paused()) {
                    player.play();
                } else {
                    player.pause();
                }
                break;
            case 'f':
                event.preventDefault();
                if (player.isFullscreen()) {
                    player.exitFullscreen();
                } else {
                    player.requestFullscreen();
                }
                break;
            case 'arrowleft':
                event.preventDefault();
                updateCurrentTime(player.currentTime() - 10);
                break;
            case 'arrowright':
                event.preventDefault();
                updateCurrentTime(player.currentTime() + 10);
                break;
            case 'arrowup':
                event.preventDefault();
                changePlaybackRate('up');
                break;
            case 'arrowdown':
                event.preventDefault();
                changePlaybackRate('down');
                break;
        }
    }

    function updateCurrentTime(newTime) {
        if (forwardTimer) {
            clearTimeout(forwardTimer);
        }

        forwardTimer = setTimeout(() => {
            player.currentTime(newTime);
            forwardTimer = null;
        }, 300);
    }

    document.addEventListener('keydown', handleKeyDown);

    player.on('dispose', function() {
        document.removeEventListener('keydown', handleKeyDown);
    });
};

videojs.registerPlugin('keyboard', Keyboard);
